import Grid from "@mui/material/Unstable_Grid2";
import Typography from "../../../Components/Typography";

export interface TabItemProps {
  title: string;
  description: string;
  content: React.ReactNode;
}

export default function TabItem(props: TabItemProps) {
  const { title, description, content } = props;
  return (
    <Grid container spacing={2}>
      <Grid xs={4}>
        <Typography variant="h4">{title}</Typography>
        <Typography variant="body4" className="text-[#676A70] pt-2">
          {description}
        </Typography>
      </Grid>
      <Grid xs={8}>{content}</Grid>
    </Grid>
  );
}
